import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconModeDark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconModeDark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '92fdc16e4b9acdf1ee483f8413330bd42fcce4a5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '08a7fe536371f8ace3c37e6f1dadefa447d1a31e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '197d8e7c01350ebc8b2e2cc8635015ffe9154c58', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.125 14.413a4.5 4.5 0 1 1-5.388-7.185q-.046.38-.046.772a6.5 6.5 0 0 0 5.434 6.413m1.1-1.413h-.034a5 5 0 0 1-4-8 5.993 5.993 0 0 0-6 6 6 6 0 0 0 11.762 1.68 5 5 0 0 1-1.729.32", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-mode-dark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mode-dark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mode-dark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconModeDark$1);
            }
            break;
    } });
}

const CosmosIconModeDark = CosmosIconModeDark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconModeDark, defineCustomElement };
